import aish from "./Heads/aish.jpg";
import bhumi from "./Heads/bhumi.jpg";
import bhoumik from "./Heads/bhoumik.jpg";
import aadit from "./Heads/aadit.png";
import komal from "./Heads/komal.jpg";
import abhi from "./Heads/abhi.jpeg";
import shrnsh from "./Heads/sharansh.jpg";
import ajay from "./Heads/ajay.png";
import vishal from "./Heads/Vishal Arya.jpeg";
import amogh from "./Heads/Amogh.png";
import nikhil from "./Heads/Nikhil2.jpg";
import praneeth from "./Heads/Praneeth2.jpg";
import mohit from "./Heads/mohit.jpg";
import jatin from "./Heads/Jatin.jpg";
import anushika from "./Heads/Anushika.jpg";
import anvesh from "./Heads/Anvesh2.jpg";
import akshat from "./Heads/Akshat.jpg";

import Saksham from "./Heads/Saksham_GS.jpg";
import Vishakha from "./Heads/Vishakha_GS.jpg";
import Neeraj from "./Heads/Neeraj.jpg";
import Dhruv from "./Heads/Dhruv.jpg";
import Dishil from "./Heads/Dishil.jpg";
import Baki from "./Heads/BAKI_VASANTH.jpg";
import Rahul from "./Heads/Rahul.jpg";
import Animesh from "./Heads/Animesh_Mondal.jpg";

const gensecdata = [
  {
    img: aish,
    name: "Aishwary Patel",
    pos: "General Secretary",
    fb: "https://www.facebook.com/profile.php?id=100074647653881",
    insta: "https://www.instagram.com/w3.aish.in/",
    linkedin: "https://www.linkedin.com/in/aishwary-patel-976298226",
    contact: "9630271203",
    mail: "aishwarypatel2004@gmail.com",
  },
  {
    img: bhumi,
    name: "Bhumi Tayal",
    pos: "General Secretary",
    fb: "https://www.facebook.com/people/Bhumi-Tayal/100074774606356/",
    linkedin: "https://www.linkedin.com/in/bhumi-tayal-725913226/",
    contact: "7684067297",
    mail: "tayalbhumi8@gmail.com",
  },
];

const webHead = [
  {
    // src: require("assets/img/denys.jpg"),
    name: "Ajay Biswas",
    pos: "Web Design Coordinator",
    img: ajay,
    fb: "https://www.facebook.com/profile.php?id=100074748354912",
    insta: "https://www.instagram.com/blue_sq4/",
    linkedin: "https://www.linkedin.com/in/ajay-biswas-8b0832237/",
    mail: "ajaybiswas44442019@gmail.com",
    contact: "7008454709",
  },
];
const eventHead = [
  {
    name: "Aadit Shah",
    img: aadit,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/aadit.shah.94?mibextid=LQQJ4d",
    linkedin: "https://www.linkedin.com/in/aadit-shah-6b291022a",
    contact: "9819250603",
    mail: "shahaadit03@gmail.com",
  },
  {
    // src: require("assets/img/denys.jpg"),
    name: "Komal Arya",
    img: komal,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/komal.arya.7359447",
    linkedin: "https://www.linkedin.com/in/komal-arya-381b0822b",
    contact: "9102515688",
    mail: "komalarya776@gmail.com",
  },

  {
    // src: require("assets/img/denys.jpg"),
    name: "Sharansh Vardhan",
    pos: "Senior Coordinator",
    img: shrnsh,
    fb: "https://www.facebook.com/profile.php?id=100023522052604&mibextid=ZbWKwL",
    linkedin: "https://www.linkedin.com/in/sharansh-vardhan-289ba9248/",
    contact: "6376339863",
    mail: "ankitkumar18175468@gmail.com",
  },
];
const sponsHead = [
  // {
  //   // src: require("assets/img/denys.jpg"),
  //   img: bhoumik,
  //   name: "Bhoumik Mhatre",
  //   pos: "Senior Coordinator",
  //   fb: "https://www.facebook.com/bhoumik.mhatre.1",
  //   linkedin: "https://www.linkedin.com/in/bhoumik-mhatre-5396b623a/",
  //   contact: "8087562959",
  //   mail: "bhoumikmhatre@gmail.com",
  // },
  // {
  //   name: "Aadit Shah",
  //   img: aadit,
  //   pos: "Senior Coordinator",
  //   fb: "https://www.facebook.com/aadit.shah.94?mibextid=LQQJ4d",
  //   linkedin: "https://www.linkedin.com/in/aadit-shah-6b291022a",
  //   contact: "9819250603",
  //   mail: "shahaadit03@gmail.com",
  // },
];
const designHead = [
  {
    // src: require("assets/img/denys.jpg"),
    name: "Ajay Biswas",
    pos: "Web Design Coordinator",
    img: ajay,
    fb: "https://www.facebook.com/profile.php?id=100074748354912",
    insta: "https://www.instagram.com/blue_sq4/",
    linkedin: "https://www.linkedin.com/in/ajay-biswas-8b0832237/",
    mail: "ajaybiswas44442019@gmail.com",
    contact: "7008454709",
  },
  {
    // src: require("assets/img/denys.jpg"),
    name: "Abhishek Tiwari",
    img: abhi,
    pos: "Graphics Design Coordinator",
    fb: "https://www.facebook.com/profile.php?id=100036010306556&mibextid=ZbWKwL",
    linkedin: "https://www.linkedin.com/in/abhishek-tiwari-5608b21a3",
    contact: "7489808207",
    mail: "Abhishekpk120@gmail.com",
  },
  {
    name: "Vishal Arya",
    img: vishal,
    pos: "Graphics Design Coordinator",
    fb: "https://www.facebook.com/vishal.arya.92351995",
    linkedin: "https://www.linkedin.com/in/vishal-arya-1ab87a23a/",
    contact: "7827523608",
    mail: "aryav7196@gmail.com",
  },
];

const gsec2024 = [
  {
    img: anushika,
    name: "Anushika Srivastava",
    pos: "General Secretary",
    fb: "https://www.facebook.com/anushika.shrivastava.102",
    linkedin: "https://www.linkedin.com/in/anushika06/",
    contact: "+91 7999850015",
    mail: "anushikashrivastava2004@gmail.com",
  },
  {
    img: praneeth,
    name: "Praneeth Kumar",
    pos: "General Secretary",
    fb: "https://www.facebook.com/profile.php?id=100090902711207",
    insta: "https://www.instagram.com/w3.aish.in/",
    linkedin: "https://www.linkedin.com/in/praneeth-kumar-sudhagani/",
    contact: "+91 7416449233",
    mail: "praneeth.sudhagani.barc.iitkgp@gmail.com",
  },
];
const publicHead2024 = [
  {
    fb: "https://www.facebook.com/amogh.ubhalkar/",
    name: "Amogh Ubhalkar",
    pos: "Public Relations Coordinator",
    linkedin: "https://www.linkedin.com/in/amogh-ubhalkar-270b81257/",
    img: amogh,
    contact: "+91 8793615083",
    mail: "ubhalkar.amogh@gmail.com",
  },
  {
    name: "Anvesh Rajguru",
    fb: "https://www.facebook.com/profile.php?id=100087759331738",
    linkedin: "https://www.linkedin.com/in/anvesh-rajguru-b07843259/",
    img: anvesh,
    pos: "Public Relations Coordinator",
    contact: "+91 7775086303",
    mail: "anveshrajguru21@gmail.com",
  },
  {
    name: "Jatain Kumar ",
    fb: "https://www.facebook.com/jatain.kumar.17/",
    linkedin: "https://www.linkedin.com/in/jatainkumar/",
    img: jatin,
    pos: "Public Relations Coordinator",
    contact: "+91 6006782092",
    mail: "jatainkumar7@gmail.com",
  },
];
const eventHead2024 = [
  {
    name: "Mohit Pant",
    fb: "https://www.facebook.com/profile.php?id=100085542944939",
    linkedin: "https://www.linkedin.com/in/mohit-pant-46790624b/",
    img: mohit,
    pos: "Events and Publicity Coordinator",
    contact: "+91 8168341986",
    mail: "mohi13245@gmail.com",
  },
];
const sponsHead2024 = [
  {
    name: "Akshat Sharma",
    fb: "https://www.facebook.com/profile.php?id=100087632920116",
    linkedin: "https://www.linkedin.com/in/akshat-sharma-2973b0273/",
    img: akshat,
    pos: "Sponsorship and Corporate Relations Coordinator",
    contact: "+91 9926159072",
    mail: "sharma.akshat0906@gmail.com",
  },
  {
    name: "Nikhil Yadav",
    fb: "https://www.facebook.com/profile.php?id=100086786409496",
    linkedin: "https://www.linkedin.com/in/nikhil-yadav181/",
    img: nikhil,
    pos: "Sponsorship and Corporate Relations Coordinator",
    contact: "+91 9616650639",
    mail: "nikhil181yadav@gmail.com",
  },
  {
    name: "Mohit Pant",
    fb: "https://www.facebook.com/profile.php?id=100085542944939",
    linkedin: "https://www.linkedin.com/in/mohit-pant-46790624b/",
    img: mohit,
    pos: "Events and Publicity Coordinator",
    contact: "+91 8168341986",
    mail: "mohi13245@gmail.com",
  },
];
const gsec2025 = [
  {
    img: Saksham,
    name: "Saksham Sinha",
    pos: "General Secretary",
    fb: "https://www.facebook.com/saksham.sinha.2025/",
    linkedin: "https://www.linkedin.com/in/saksham-sinha-22b026286/",
    contact: "+91 7033269474",
    mail: "sakshamsinha2235@gmail.com",
  },
  {
    img:  Vishakha,
    name: "Vishakha Priya",
    pos: "General Secretary",
    fb: "https://www.facebook.com/p/Vishakha-Priya-61550345141284/",
    linkedin: "https://www.linkedin.com/in/vishakha-priya-9b4b192bb/",
    contact: "+91 9060560310",
    mail: "vishakhapriya12@gmail.com",
  },
];
const publicHead2025 = [
  {
    name: "A.Neeraj Kumar",
    fb: "https://www.facebook.com/neeraj.a.927980/",
    pos: "Events and Publicity Coordinator",
    linkedin: "https://www.linkedin.com/in/annangi-neeraj-kumar-4ab546259/",
    img: Neeraj,
    contact: "+91 8328003149",
    mail: "neerajannangi1@gmail.com",
  },
  {
    name: "Dhruv Sailor",
    fb: "https://www.facebook.com/profile.php?id=61565353710467",
    linkedin: "https://www.linkedin.com/in/dhruv-sailor-91201a31a/",
    img: Dhruv,
    pos: "Sponsorship and Corporate Relations Coordinator",
    contact: "+91 7990898308",
    mail: "dhruvsailorsail@gmail.com",
  },
  {
    name: "Zalavadiya Dishil",
    fb: "https://www.facebook.com/dishil.zalavadia.7/friends/",
    linkedin: "https://www.linkedin.com/in/dishil-zalavadiya-943020280/",
    img: Dishil,
    pos: "Sponsorship and Corporate Relations Coordinator",
    contact: "+91 9925492574",
    mail: "dishil2906@gmail.com",
  },
];

const sponsHead2025 = [
  {
    name: "Rahul RS",
    fb: "https://www.facebook.com/p/Rahul-R-S-61561550024821/",
    linkedin: "https://www.linkedin.com/in/rahulrsiitkgp/",
    img: Rahul,
    pos: "Public Relations Coordinator ",
    contact: "+91 7736479584",
    mail: "rahulrs1500@gmail.com",
  },
  {
    name: "Animesh Mondal",
    fb: "https://www.facebook.com/profile.php?id=61551232860755",
    linkedin: "https://www.linkedin.com/in/animesh-mondal-4b702527a/",
    img: Animesh,
    pos: "Public Relations Coordinator ",
    contact: "+91 9316227078",
    mail: "animeshtxt@gmail.com",
  },
   {
    name: "Baki Vasanth",
    fb: "https://www.facebook.com/profile.php?id=61550639309609",
    linkedin: "https://www.linkedin.com/in/vasanth-baki-26689228a/",
    img: Baki,
    pos: "Public Relations Coordinator ",
    contact: "+91 9398970715",
    mail: "bakivasanth2004@gmail.com",
  },
  
];
export {
  gensecdata,
  webHead,
  designHead,
  eventHead,
  sponsHead,
  aish,
  gsec2024,
  eventHead2024,
  publicHead2024,
  sponsHead2024,
  gsec2025,
  publicHead2025,
  sponsHead2025,
};
